import { Loader2 } from 'lucide-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/features/auth/hooks/useAuth';
import { loginComRetorno } from '@/shared/lib/rotas';

/**
 * Guarda de SESSÃO apenas (F2-3).
 *
 * Permissão de rota é outro wrapper (`RotaComPermissao`, a partir da F3/F6),
 * que renderiza a tela 403 em vez de redirecionar. Misturar os dois faz o
 * usuário sem permissão cair no login, que é a mensagem errada.
 */
export function PrivateRoute() {
  const { autenticado, carregando } = useAuth();
  const { pathname, search } = useLocation();

  if (carregando) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-surface">
        <Loader2 className="h-12 w-12 animate-spin text-brand" />
        <p className="text-sm text-muted-foreground">Carregando...</p>
      </div>
    );
  }

  if (!autenticado) {
    // `next` preserva o destino: depois do login o usuário volta para onde
    // tentou ir, em vez de cair sempre no dashboard.
    return <Navigate to={loginComRetorno(pathname + search)} replace />;
  }

  return <Outlet />;
}
